module.exports = __webpack_public_path__ + "media/svg/validatelogoblack-b1980b06.svg";